<template>
  <div class="orders" :class="orderList.length > 3 ? '' : 'ht'">
    <!-- 头部 -->
    <header>
      <div class="header">
        <div class="order-header-back">
          <van-icon name="arrow-left" class="i" @click="orderBack" />
          <span>提交订单</span>
        </div>
      </div>
    </header>

    <!-- 选择配送地址 -->
    <div class="dispatch">
      <van-cell is-link @click="showPopup">
        <div>
          <van-row
            gutter="20"
            class="orders-van-row"
            style="padding: 0; padding-bottom: 5px"
          >
            <van-col span="8" class="orders-van-col">配送地址</van-col>
          </van-row>
          <van-row
            gutter="20"
            class="orders-van-row"
            style="padding: 0"
            v-show="showPrice"
          >
            <van-col span="8" class="orders-van-col chose">请选择</van-col>
          </van-row>
        </div>
        <div class="dispatch-price chose" v-show="!showPrice">{{ place }}</div>
      </van-cell>
      <van-popup v-model="showPp" position="bottom" :style="{ height: '30%' }">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="onCancel"
          @confirm="onConfirm"
          :default-index="0"
        />
      </van-popup>

      <div class="orders-time">
        <van-row gutter="20" class="orders-van-row oddr">
          <van-col span="8" class="orders-van-col">配送日期</van-col>
        </van-row>
        <van-cell
          is-link
           style="padding-bottom: 0 !important"
          @click="showDataTime"
          v-show="!showTime"
          class="lateDay"
          >{{ lateDay }}</van-cell
        >

        <van-row
          gutter="20"
          class="orders-van-row"
          v-show="showTime"
          style="padding-bottom: 0 !important"
        >
          <van-col span="6">
            <van-tag color="#F7F7F7" text-color="#74B42B" @click="tomorrow"
              >明日配送</van-tag
            >
          </van-col>
          <van-col span="6">
            <van-tag color="#F7F7F7" text-color="#74B42B" @click="after"
              >后天配送</van-tag
            >
          </van-col>
          <van-col span="6">
            <van-tag color="#F7F7F7" text-color="#74B42B" @click="others"
              >其他日期</van-tag
            >
          </van-col>
        </van-row>
      </div>

      <!-- 订单类型 -->
      <van-cell is-link @click="propOrderClick" :disabled="deliveryId">
        <div class="order-type">
          <van-row
            gutter="20"
            class="orders-van-row"
            style="
              padding: 0;
              padding-bottom: 5px;
              border-top: 1px dashed #f7f7f7;
              padding-top: 5px;
            "
          >
            <van-col span="8" class="orders-van-col">订单类型</van-col>
          </van-row>
          <van-row
            gutter="20"
            class="orders-van-row"
            style="padding: 0"
            v-show="showOrderType"
          >
            <van-col span="8" class="orders-van-col chose">请选择</van-col>
          </van-row>
        </div>
        <div class="dispatch-price chose" v-show="!showOrderType">
          {{ customerOrderType }}
        </div>
      </van-cell>
      <van-popup
        v-model="showPropOrder"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          ref="showPropOrder"
          show-toolbar
          :columns="orderColumns"
          @cancel="showPropOrder = false"
          @confirm="onOrderConfirm"
          value-key="customerOrderType"
          :default-index="0"
        />
      </van-popup>
    </div>

    <!-- 选择日期 -->
    <van-popup v-model="showData" position="bottom">
      <van-datetime-picker
        class="orders-datatime"
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm"
         @cancel="showData = false"
      />
    </van-popup>

    <!-- 订单号 -->
    <!-- <div class="ordersNum">订单345234654</div> -->
    <!-- 订单列表 -->
    <div class="ordersList" style="position: relative; padding-bottom: 90px">
      <div class="goodList" v-for="index in orderList" :key="index.cartId">
        <div class="ty-top">
          <img
            :src="index.picUrl"
            alt
            style="object-fit: cover; margin-right: 5px"
          />
          <p class="text1">{{ index.goodsName }}</p>
          <br />
          <div class="weight">
            ￥{{ index.salePrice / index.saleRatio }}/{{ index.goodsUnitLabel }}
          </div>
          <div class="text3">
            <span class="ty-left">
              ￥{{ index.salePrice }}/{{ index.saleUnitLabel }}
              <span
                v-if="
                  index.saleRatio != 1 || 
                  index.goodsUnitLabel != index.saleUnitLabel
                "
                >({{ index.saleRatio }}{{ index.goodsUnitLabel }})</span
              >
            </span>
            <span class="ty-right">x{{ index.orderQty }}</span>
          </div>
          <!-- 备注 -->
          <div class="remark van-ellipsis" v-if="index.remark">
            备注：{{ index.remark }}
          </div>
        </div>
      </div>
    </div>
    <van-submit-bar
      :loading="loading"
      :price="totalPrice"
      button-text="提交订单"
      @submit="submitOrder"
      tip-icon="warning"
      tip="最终结算金额以最终送货单为准"
      safe-area-inset-bottom
      button-type="info round"
    >
      <div class="orders-submit-bar">共{{ orderListLength }}件</div>
    </van-submit-bar>
    <van-dialog
      class="order_allChose"
      v-model="show"
      title="选择已录入订单"
      :before-close="orderCombine"
      confirmButtonColor="#74b42b"
      confirmButtonText="确认合单"
      show-cancel-button
    >
      <van-list>
        <div slot="default">
          <van-radio-group v-model="choseOrder">
            <!-- dateFilter <van-icon name="stop-circle-o" /> -->
            <van-radio
              v-for="item in list"
              :key="item.orderId"
              :name="item.orderId"
            >
              <van-row type="flex" justify="space-between">
                <van-col> 订单{{ item.orderCode }} </van-col>
                <van-col>
                  {{ item.deliveryTime | timeFilter }}
                </van-col>
              </van-row>
              <template slot="icon">
                <van-icon size="14px" name="stop-circle-o" />
              </template>
            </van-radio>
          </van-radio-group>
        </div>
      </van-list>
    </van-dialog>
  </div>
</template>

<script>
export default {
  created() {
    // 获取购物车选择数据
    this.orderList = JSON.parse(localStorage.getItem("children"));
    // 获取客户Id
    this.customerId = localStorage.getItem("customerId");
    // 获取配送信息
    this.$axios
      .get(`/customer/customerDelivery/customer/${this.customerId}`)
      .then((res) => {
        this.priceList = res.data.data;
        res.data.data.forEach((item) => {
          this.columns.push(item.name);
        });

      });
  },
  data() {
    return {
      loading: false,
      orderList: [], //订单列表
      show: false,
      customerId: "", //用户ID
      showPp: false, //popup框显示
      columns: [], // 选择框列表
      priceList: [], //地址列表
      deliveryId: "", //地址ID
      showPrice: true, //显示已选地址
      place: "", //已选地址
      deliveryTime: "", //后台传输时间
      choseOrder: "",
      lateDay: "", //前端展示时间
      showTime: true, //显示时间
      currentDate: new Date(), //选择日期
      showData: false, //下弹出框
      minDate: new Date(), //选择最小时间
      maxDate: new Date(2022, 10, 1), //选择最大时间
      orderId: "", // 订单ID
      list: [],
      showOrderType: true, //用来显示订单类型
      showPropOrder: false, //订单类型弹窗
      orderColumns: [], //订单类型数据
      customerOrderType:'', //订单类型名称
      customerOrderId:'' , // 订单类型ID
    };
  },
  watch: {
    deliveryId(val) {
      // 获取订单类型
      this.$axios
        .post("/trade/tradeCustomerOrderType/list", {
          customerId: this.customerId,
          deliveryId: val,
        })
        .then((res) => {
          if (res.data) {
            this.orderColumns = res.data.data
          }
        })
        .catch(() => {});
    },
  },
  methods: {
    //合单接口 /allTradeOrder/customer/combine
    orderCombine(action, done) {
      if (action == "cancel") {
        done();
      } else {
        //选择需要合单的信息
        this.$axios
          .post("/trade/allTradeOrder/customer/combine", {
            orderId: this.choseOrder,
            children: this.orderList,
          })
          .then((res) => {
            if (res.data.data) {
              done();
              this.$router.push({
                path: "/SendList",
                query: { orderId: this.choseOrder, text: "卖家代发货" },
              });
            }
          })
          .catch(() => {
            done(false);
          });
      }
    },
    propOrderClick(){
      if(!this.deliveryId) return false
      this.showPropOrder = true
    },
    // 提交订单
    onSubmit() {
      if (!this.place || !this.deliveryTime) {
        this.$toast("配送地址或配送时间不能为空");
      } else {
        //校验是否合单
        ///allTradeOrder/checkCombine
        this.$axios
          .post("/trade/allTradeOrder/checkCombine", {
            deliveryId: this.deliveryId,
            deliveryTime: this.deliveryTime,
            customerId: this.customerId,
            goodsKindValue: "0",
          })
          .then((res) => {
            // 有合单
            if (res.data.data.length > 0) {
              this.$dialog
                .confirm({
                  title: "提示",
                  message:
                    "今日已有订单，是否想要与之前订单合并订单？(分成多个订单将计算两次运费)",
                  confirmButtonColor: "#74b42b",
                  confirmButtonText: "合单",
                  cancelButtonText: "不合单",
                })
                .then(() => {
                  this.list = res.data.data;
                  this.choseOrder = this.list[0].orderId;
                  this.show = true;
                })
                .catch(() => {
                  this.submitOrder();
                });
            } else {
              //无需要合单
              this.submitOrder();
            }
          });
      }
    },
    //提交订单
    submitOrder() {
      if (!this.place || !this.deliveryTime) {
        this.$toast("配送地址或配送时间不能为空")
        return  false
      }
      this.loading = true
      this.$axios
        .post(`/trade/tradeOrder/save`, {
          deliveryId: this.deliveryId,
          deliveryTime: this.deliveryTime,
          customerId: this.customerId,
          goodsKindValue: "0",
          children: this.orderList,
          customerOrderId:this.customerOrderId,
          customerOrderType:this.customerOrderType
        })
        .then((res) => {
          this.orderId = res.data.data;
          this.$router.push({
            path: "/SendList",
            query: { orderId: this.orderId, text: "卖家代发货" },
          });
          this.loading = false
        }, () => { 
          this.$toast("网络连接失败，请检查你的网络！")
          this.loading = false 
        });
    },
    // 回退
    orderBack() {
      window.history.back();
    },
    // 配送时间选择
    deliveryTM(day) {
      // 往后台传输的数据
      this.deliveryTime = this.$moment()
        .add(+day, "day")
        .toDate();
      // 前台展示数据
      this.lateDay = this.$moment()
        .add(+day, "day")
        .format("YYYY-MM-DD");
      this.showTime = false;
    },
    // 明日配送
    tomorrow() {
      this.deliveryTM(1);
    },
    //后天配送
    after() {
      this.deliveryTM(2);
    },
    // 其他时间
    others() {
      this.showData = true;
    },
    // 选择弹出层
    showPopup() {
      this.showPp = true;
    },
    //点击取消
    onCancel() {
      this.showPp = false;
    },
    // 手动选择时间
    showDataTime() {
      this.showData = true;
    },
    // 修改时间样式
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
      return value;
    },
    // 点击确认
    onConfirm(value) {
      this.place = value;
      this.priceList.forEach((item) => {
        if (item.name == value) {
          this.deliveryId = item.deliveryId;
        }
      });
      this.showPp = false;
      this.showPrice = false;
      // this.orderColumns = []
      this.customerOrderType = ''
      // this.showOrderType = true;
    },
    onOrderConfirm(){
      this.customerOrderType = this.$refs.showPropOrder.getValues()[0].customerOrderType
      this.customerOrderId = this.$refs.showPropOrder.getValues()[0].customerOrderId
      this.showOrderType =  false
      this.showPropOrder = false
    },
    // 时间按确认
    confirm(value) {
      this.deliveryTime = value;
      this.showTime = false;
      this.lateDay = this.$moment(value).format("YYYY-MM-DD");
      this.showData = false;
    },
  },

  computed: {
    // 合计价格
    totalPrice() {
      return this.orderList.reduce((price, item) => {
        price += item.orderQty * item.salePrice * 100;
        return price;
      }, 0);
    },
    // 总件数
    orderListLength() {
      return this.orderList.length;
    },
  },
};
</script>

<style   lang='scss' scoped>
.ht {
  height: 100%;
}
.orders {
  background: rgba(242, 242, 242, 1);
  /* height: 100%; */
  padding-top: 40px;
}
.order-header-back {
  width: 80px;
}
.header {
  background: rgba(237, 237, 237, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: rgba(102, 102, 102, 1);
  position: relative;
  padding-left: 30px;
}
.i {
  position: absolute;
  top: 13px;
  left: 10px;
}
.dispatch {
  margin: 12px auto;
  /* margin-left: 3%; */
  width: 90%;
  background-color: #fff;
  box-shadow: 0px 1px 2px 0px rgba(153, 153, 153, 0.5);
  border-radius: 8px;
}
.van-cell--clickable {
  border-radius: 8px;
}
.van-cell__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-bottom: 7px;
}
.van-cell__right-icon {
  position: absolute;
  top: 45%;
  right: 7%;
}
.van-cell__title {
  border-bottom: 1px dashed #999;
}
.orders-van-row {
  padding-left: 16px;
  padding-bottom: 10px;
}
.oddr {
  padding-bottom: 3px;
}
.orders-van-col {
  font-size: 12px;
  position: relative;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.ordersNum {
  padding-left: 3%;
  line-height: 32px;
  background: rgba(237, 237, 237, 1);
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
}
.van-submit-bar__button[data-v-162ab658] {
  margin-right: 0px !important;
}
.ty-top {
  width: 85%;
  position: relative;
  background-color: #fff;
  margin: 0 auto;
  margin-bottom: 2%;
  border-radius: 10px;
  padding: 8px;
  padding-left: 13px;
  padding-bottom: 6px;
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  font-size: 12px;
  overflow: hidden;
}
.sign {
  position: absolute;
  padding-left: 20px;
  box-sizing: border-box;
  right: 0;
  width: 90px;
  height: 24px;
  line-height: 24px;
  background: linear-gradient(
    90deg,
    rgba(116, 180, 43, 0) 0%,
    rgba(116, 180, 43, 0.5) 22%,
    rgba(116, 180, 43, 1) 100%
  );
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 2px;
}
.place1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.place2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dddddd;
  margin: 5px 0;
}
.time1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.time2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}
.ty-center {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  background: rgba(237, 237, 237, 1);
  padding-left: 5%;
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
}
img {
  float: left;
  width: 80px;
  height: 88px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
}
.text1 {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.text2 {
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
}
.weight {
  width: 68px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
  float: left;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 21px;
  border-radius: 10%;
}
.ty-left {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 22px;
}
.ty-right {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  float: right;
}
.text3 {
  margin: 35px 0 10px;
  padding-left: 80px;
  padding-right: 8px;
}
.remark {
  margin-top: 50px;
  width: 95%;
  margin: 0 auto;
  background: rgba(102, 102, 102, 0.05);
  border-radius: 8px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  padding-left: 10px;
}
.orderList /deep/ .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orderList /deep/ .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.van-submit-bar__button {
  margin-left: 3%;
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border: 0px solid #000;
  border-radius: 50px;
  height: 80%;
  line-height: 80%;
  margin-right: 10px;
}
.orderList /deep/ .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orderList /deep/ .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.van-submit-bar__button {
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border: 0px solid #000;
  border-radius: 50px;
  height: 80%;
  line-height: 80%;
  margin-right: 10px;
}
.van-submit-bar {
  background-color: rgba(237, 237, 237, 1);
}
.van-submit-bar__bar {
  padding-left: 3%;
}
.van-submit-bar__tip {
  padding: 2px 16px;
  background-color: rgba(245, 166, 35, 0.1);
}
.van-submit-bar__price {
  color: rgba(245, 166, 35, 1);
}
.orders-submit-bar {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.orders /deep/ .van-picker__confirm,
.orders /deep/ .van-picker__cancel {
  color: #74b42b !important;
}
.chose {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  font-size: 16px;
}
.lateDay /deep/ .van-cell__value,
.van-cell__value--alone {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}
.van-cell__right-icon[data-v-162ab658] {
  right: 5%;
}
.lateDay .van-cell__right-icon[data-v-162ab658] {
  top: -4%;
}
.orders-time .van-cell[data-v-162ab658]:not(:last-child)::after {
  width: 0;
}
.lateDay {
  padding-top: 3px;
}
header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}
.van-cell:not(:last-child)::after {
  height: 10px;
  width: 90%;
}
.order_allChose {
  font-size: 14px;
  /deep/ .van-icon {
    border: 1px solid #74b42b;
  }
  /deep/ .van-radio__icon--checked .van-icon {
    border-color: #74b42b;
    background-color: #74b42b;
  }
  /deep/ .van-dialog__content {
    height: 182px;
    padding: 20px 32px;
    overflow: scroll;
  }
  /deep/ .van-radio {
    margin-bottom: 16px;
  }
  /deep/ .van-radio__label {
    margin-left: 12px;
    display: block;
    width: 100%;
  }
}
</style>